export interface IPdpQuestionAndAnswer {
    pdpGuid?: string;
    guid?: string;
    title: string;
    description: string;
    question: string;
    answer: string;
}

export const initPdpQuestionAndAnswer: IPdpQuestionAndAnswer = {
    title: "",
    description: "",
    question: "",
    answer: ""
};